import { useEffect, useState } from "react"
import "./eachProCom.css"
import CurrencyFormat from "react-currency-format"
import { useParams } from "react-router-dom"
import { useGlobalContext } from "../../context"
import { FaMinus } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa6";
import { handleGetEachData } from "../../requests/productRequests"

function EachProCom() {
    const { id } = useParams()
    const [img, setImg] = useState("")
    const {
        setSize,
        size,
        handleQuentity,
        handleAddProductToCart,
        setProduct,
        product,
        setQtyInStore, } = useGlobalContext()

    useEffect(async () => {
        window.location = "#"
        let find;
        try{
            find = await handleGetEachData(id)
        }catch(err){
            console.log(err)
        }
        let product = {
            name: find.title,
            img: find.img,
            code: find.productCode,
            price: find.price,
            size: find.sizes,
            qty: 1,
            store: find.instock
        }
        setSize("")
        setQtyInStore("")
        setProduct(product)
        setImg(product.img[0])
    }, [id])
    const handleZoom = (e) => {
        let x = Math.floor((e.clientX * 100) / e.target.offsetWidth - imageres())
        let y = Math.floor((e.clientY * 100) / e.target.clientHeight)
        e.target.style.backgroundPosition = `${x >= 100 ? 100 : x <= 0 ? 0 : x}% ${y >= 100 ? 100 : y}%`
    }
    const imageres = () => {
        if (window.innerWidth > 850) {
            return 250
        } else {
            return 0
        }
    }
    return (
        <div className="pro-cont">
            <div className="right-eachproduct">
                <div className="r-img-eachproduct">
                    <div className="img-e" >
                        <img src={img} alt="" />
                        <div style={{ backgroundImage: `url(${img})` }} onMouseMove={e => handleZoom(e)} className="img-zoomer"></div>
                    </div>
                    <div className="imgs-e">
                        {
                            product.img &&
                            product.img.map((item, i) => {
                                return (
                                    <img src={item} onClick={(e) => setImg(e.target.src)} alt="" key={i} />
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            <div className="left-eachproduct">
                <div className="pro-name">
                    <h2>{product.name}</h2>
                </div>
                <div className="pro-code">
                    <span>کد محصول : {product.code}</span>
                </div>
                <div className="pro-price">
                    <h1>
                        <CurrencyFormat
                            thousandSeparator={true}
                            value={product.price}
                            prefix="تومان"
                            displayType="text"></CurrencyFormat>
                    </h1>
                </div>
                <div className="pro-sizes">
                    <span>سایز : </span>
                    <ul>
                        {
                            product.size &&
                            product.size.map((item, i) => {
                                return (
                                    <li onClick={(e) => {
                                        setSize(item)
                                        setQtyInStore(product.store[i])
                                        setProduct({ ...product, qty: 1 })
                                    }} className={product.store[i] == 0 ? "size-none" : ""} key={i}>
                                        <button className={size == item ? "selected-size selected" : "selected-size"}>
                                            <span>{item}</span>
                                        </button>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
                <div className="qty">
                    <span>تعداد : </span>
                    <div>
                        <button className={size ? "incbtn" : "incbtn nonebtn"} onClick={() => handleQuentity("I")}><FaPlus/></button>
                        <span>{product.qty}</span>
                        <button onClick={() => handleQuentity("D")}><FaMinus/></button>
                    </div>
                </div>
                <div className="subtocart">
                    <button onClick={() => handleAddProductToCart()}>افزودن به سبد</button>
                </div>
                <div className="desc">
                    <span>توضیحات</span>
                    <p>ته:
                        :1 ]49031[ اموزش زبان وادبيات فارسي | دانشگاه فرهنگيان -پرديس شهيدبهشتي مشهد | کارشناسي | با آزمون | فرهنگيان - آزاد | شهر محل تحصيل : مشهد | نيمسال اول |
                        :2 ]48995[ اموزش زبان عربي | دانشگاه فرهنگيان -پرديس شهيدبهشتي مشهد | کارشناسي | با آزمون | فرهنگيان - آزاد | شهر محل تحصيل : مشهد | نيمسال اول |
                        :3 ]48841[ اموزش الهيات | دانشگاه فرهنگيان -پرديس شهيدبهشتي مشهد | کارشناسي | با آزمون | فرهنگيان - آزاد | شهر محل تحصيل : مشهد | نيمسال اول |
                        :4 ]48842[ اموزش الهيات | دانشگاه فرهنگيان -پرديس شهيدبهشتي مشهد | کارشناسي | با آزمون | فرهنگيان - آزاد | شهر محل تحصيل : مشهد | نيمسال اول |</p>
                </div>
            </div>
        </div>
    )
}

export default EachProCom;